import DefaultStage from './DefaultStage';

export default DefaultStage;
